import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const BbotRichTextInput = ({ ...props }) => {
  return <ReactQuill theme="snow" {...props} />;
};

export default BbotRichTextInput;
